import React from 'react';

import GeneralLedgerComponent from '../../../components/public/GeneralLedger';

class GeneralLedger extends React.PureComponent {
  render() {
    return (
      <GeneralLedgerComponent />
    );
  }
}

export default GeneralLedger;